import React from "react";

const Footer = () => {
  return (
    <div
      style={{
        background: "black",
        color: "white",
        textAlign: "center",
        paddingTop: 10,
        paddingBottom: 10,
        fontWeight: 600,
        letterSpacing: 0.4,
      }}
    >
      © 2024 CDRReportHub. All Rights Reserved
    </div>
  );
};

export default Footer;
